import withURLSearchParamsHandler from "../../../../../../components/hoc/withURLSearchParamsHandler";
import UserHistory from "./UserHistory";

const UserHistoryWithURLSearchParamsHandler = withURLSearchParamsHandler(UserHistory);
export default UserHistoryWithURLSearchParamsHandler;